module.exports = __webpack_public_path__ + "img/Feature.ce22ea97.png";